<template>
    <div class="attr">
        <span class="attr-label">{{ value.label }}</span>
        <div class="attr-value" v-html="value.value"></div>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'ClassicAttribute',
    props: ['value']
}
</script>

<style scoped>
.attr-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 4px;
}

.attr-value {
    font-size: 0.9rem;
    color: #1e293b;
    line-height: 1.6;
    word-break: break-word;
}
</style>
